import React, { Component } from 'react'
import {
	Col,
	FormGroup,
	Button
} from "react-bootstrap";
import moment from 'moment'
import {   reduxForm, propTypes,formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { 
	resetWizardState, 
	uploadResultsFile, 
	uploadingResultsFile, 
	prestineNavigateNext 
} from "../../../../redux/actions/action_postEvent";
import {  blue,videoblue, gray, warning, StatusDescription } from "../../../../utils/constants"
import { STEP_SEQUENCE } from '../../logic';

const FormName = 'postevent'
const fileInputStyle = {
	maxWidth:'230px',
	borderRadius:'0',
	fontSize:'14px',
	padding:'5px',
	color:blue ,
	maxHeight:'32px',
	fontWeight:'bold',
}

class UploadFinalStandings extends Component {
 
	static propTypes = {
		...propTypes
	}
	constructor(props)
	{  
		super(props)
		this.state = {
			resultsFile:'',
		}
		this.uploadEventResults = this.uploadEventResults.bind(this);
		this.handleOnFileChange = this.handleOnFileChange.bind(this);
		this.handleSaveTemplate = this.handleSaveTemplate.bind(this);
	}
	componentDidMount(){
		window.scrollTo(0, 0)
		this.props.dispatch(resetWizardState(STEP_SEQUENCE.UploadFinalStandings));
	}
	uploadEventResults() {
    if(this.props.currentWizardStep !== STEP_SEQUENCE.FeePayment)
		{
			const { eventId } = this.props;
			const resultsfile = this.uploadInput.files[0];
			const formData = new FormData();

			formData.append('eventId',eventId);
			formData.append('resultsfile', resultsfile);
			
			if(resultsfile !== undefined){
				this.props.dispatch(uploadingResultsFile());
				this.props.dispatch(uploadResultsFile(formData));
			}			
		} 
		else {
			this.props.dispatch(prestineNavigateNext());
		}
	}

	handleSaveTemplate(e)
	{
		e.preventDefault();
		this.uploadEventResults();
	}   

	handleOnFileChange()
    {
			const fileSelected = this.uploadInput.files[0] ? true:false
			const resultsFile =  fileSelected == true ? this.uploadInput.files[0].name:''
			this.setState({ 
				resultsFile
			}) 
    }

	render() {
		const { resultsFile } = this.state
		const {
      uploadingResults
		} = this.props;

		const resultsSelected = ((resultsFile == undefined) || (resultsFile.length == 0)) ? false:true
		const fileMessage = resultsSelected == true ? resultsFile:'No file selected.'
		const fileMessageColor = resultsSelected  == true? videoblue:warning
		const uploadingIcon = uploadingResults === true  ? "fa fa-spinner fa-spin":"fa fa-upload"
		const resultsFileMissing = resultsFile === '' || resultsFile === undefined

		const {  eventname,
			resultsUploadedOn,
			saveComponentState,
			componentStateSaved,
      currentWizardStep,
      roleName,
      status
    } = this.props;

   const isAdministrator = roleName == 'Administrator';

	const resultsUploaded = (resultsUploadedOn !== null) && (resultsUploadedOn !== undefined);
	
	if(currentWizardStep === STEP_SEQUENCE.UploadFinalStandings)
	{
		if((saveComponentState === true) && (componentStateSaved === false))
		{
			this.uploadEventResults();
		} 
		if(componentStateSaved === true)
		{
			this.props.onComponentStateSaved(componentStateSaved)
		}
		if(!resultsUploaded)
		{
			this.props.onComponentStateSaved(false)
		}
  }

    return (
		<div style={{ marginTop:'1%' }} sm={6}>
			{
				(
					<Col sm={12} style={{ border:`1px solid ${gray}`, padding:'15px' , marginRight:'0px', marginBottom:'15px' }} >
						<FormGroup style={{ padding:'0 0 15px 25px', margin:'0' }}>
							<h4 className='text-left'  style={{ color:blue }}>{' '}Event Name - {eventname}</h4>
							<br />
							<form id='postevent' encType="multipart/form-data" onSubmit={this.handleSaveTemplate} role="form" className="form-inline" style={{ margin:'-15px 0' }}>
                <label className="btn btn-default" style={fileInputStyle} disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)} >
                  <i className="fa fa-file" aria-hidden="true"/>&nbsp;{' '}Select Final Standings File  {' '}
                  <input type='file' accept=".*" id="rulefile" ref={(ref) => { this.uploadInput = ref; }} style={{ display: 'none', marginTop: '20px' }} onChange={this.handleOnFileChange}
                      disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)} />                        
								</label>
								<Button  onClick={this.handleSaveTemplate} style={{ ...fileInputStyle, margin:'0 2px',  }} disabled={ resultsFileMissing }>
									<i className={uploadingIcon} aria-hidden="true" />&nbsp;&nbsp;Upload Final Standings
								</Button>
								<label style={{ minWidth:'240px',color:fileMessageColor,fontWeight:'bold' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										{fileMessage}
								</label><br />
								<br />
								{ 
									resultsUploaded &&
									(<span style={{ fontSize:'14px', fontWeight:'bold' }}>
										<i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;Event results uploaded on&nbsp; {moment(resultsUploadedOn, 'YYYY-MM-DD').format('LL')}.
									</span>)
								} 
							</form>			
								{
									!resultsUploaded && (<span>
									<h5 className='text-left'  style={{ color:warning, marginTop:'15px' }}><i className="fa fa-exclamation-triangle" />&nbsp;&nbsp;You have not submitted your event results yet. You can upload them in any file format.</h5>
                  <h5 className='text-left'  style={{ color:warning, marginTop:'15px' }}><i className="fa fa-exclamation-triangle" />For multiple pages, you must select and upload each file/page individually.</h5></span>)
								}
						</FormGroup>									
					</Col>		
				)
			} 
		</div>)
	}
}
function mapStateToProps(state,ownProps){
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const eventId               = selector(state,'eventId')
	const eventname             = selector(state,'eventname')
	const resultsUploadedOn   = selector(state,'resultsUploadedOn')
	const componentStateSaved = selector(state,'componentStateSaved')
	const currentWizardStep = selector(state,'currentWizardStep')
  const uploadingResults = selector(state, 'uploadingResults');
  const roleName = state.user.roleName
  const status = selector(state, 'status')
	return {
		eventname,
		eventId,
		resultsUploadedOn,
		uploadingResults,
		componentStateSaved,
    currentWizardStep,
    roleName,
    status
  }
}  
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		resetWizardState, 
		uploadResultsFile, 
		uploadingResultsFile, 
		prestineNavigateNext 
	},dispatch)
}
UploadFinalStandings.propTypes = {
	dispatch:PropTypes.func,
	eventId:PropTypes.number,
	eventname:PropTypes.string,
	resultsUploadedOn: PropTypes.string,
	uploadingResults:PropTypes.bool,
	onComponentStateSaved: PropTypes.func,
	componentStateSaved: PropTypes.bool,
	saveComponentState:PropTypes.bool,
  currentWizardStep: PropTypes.number,
  roleName: PropTypes.string,
  status: PropTypes.string
}
export default reduxForm({
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(UploadFinalStandings))
    



// WEBPACK FOOTER //
// ./src/containers/postevent/components/finalStandings/index.js